import type { ReactElement, ReactNode } from "react";
import { Ccontainer } from "../Ccontainer";
import { ContainerPreset } from "@/constants/componentPresets";
import { TOOLTIP_CONTAINER_BACKDROP_BLUR, TOOLTIP_CONTAINER_GAP, TOOLTIP_CONTAINER_PADDING, TOOLTIP_CONTAINER_RADIUS, TOOLTIP_CONTAINER_ROOT_MOTION, TOOLTIP_CONTAINER_STYLE, TOOLTIP_CONTENT_STYLE, } from "./ctooltip-constants";
import { dataEl, type DataElScope } from "@/utils/dataEl";
interface CtooltipContentProps {
    dataElScope: DataElScope;
    children: ReactNode;
}
export function CtooltipContent({ dataElScope, children, }: CtooltipContentProps): ReactElement {
    return (
      <div data-el={dataEl(dataElScope, "Content/Root")} style={TOOLTIP_CONTENT_STYLE}>
        <Ccontainer preset={ContainerPreset.Secondary} padding={TOOLTIP_CONTAINER_PADDING} radius={TOOLTIP_CONTAINER_RADIUS} backdropBlur={TOOLTIP_CONTAINER_BACKDROP_BLUR} flexDirection="column" gap={TOOLTIP_CONTAINER_GAP} rootMotion={TOOLTIP_CONTAINER_ROOT_MOTION} style={TOOLTIP_CONTAINER_STYLE}>
          {children}
        </Ccontainer>
      </div>
    );
}
